import React, { useState, useEffect } from 'react';
import DateService from '../../services/DateService';
import Loader from '../../components/ui/Loader/Loader';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { fetchNotifications, getCachedData, markReadAndRefresh, } from '../../services/NotificationData';
import TapIcon from '../../services/TapIcon';
import { getRedirectUrl } from '../../services/NotificationNavigation';

const AllNotifications = (props) => {
    let history                                 =   useHistory();
    const { open, onClose, updateUnreadCount } = props;
    const access_token = useSelector(state => state.auth.access_token);
    const [notificationData, setNotificationData] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const loadNotifications = (refresh = false) => {
        if (!access_token) return;

        fetchNotifications(
            access_token,
            (notifications, count) => {
                setNotificationData([...notifications]);
                setUnreadCount(count);
                updateUnreadCount && updateUnreadCount(count);
            },
            refresh
        );
    };

    useEffect(() => {
        if (access_token) {
            loadNotifications(false);
        }
    }, [access_token]);

    useEffect(() => {
        if (open) {
            const cached = getCachedData();
            setNotificationData(cached.notifications);
            setUnreadCount(cached.unreadCount);
            if (updateUnreadCount) {
                updateUnreadCount(cached.unreadCount);
            }
            if (!cached.isFetched) {
                loadNotifications(true);
            }
        }
    }, [open]);

    const markNotificationAsRead = (id, currentStatus) => {
         if (loading) return
        setLoading(true);
        markReadAndRefresh(id, currentStatus, access_token, (success, notifications, count) => {
            if (success) {
                setNotificationData([...notifications]);
                setUnreadCount(count);
                updateUnreadCount && updateUnreadCount(count);
            }
            setLoading(false);
        });
    };
    const handleViewAll = () => {
        onClose();
        history.push('/notification_logs');
    };

    const handleNotificationClick = (item) => {
        // if (item.is_read !== 1 && !loading) {
        //     markNotificationAsRead(item.id, item.is_read);
        // }

        const redirectUrl = getRedirectUrl(item.data, false);
        onClose && onClose();
        redirectUrl && history.push(redirectUrl);
    };

    
    const handleRefresh = () => {
        if (!access_token) return;

        setLoading(true);
        fetchNotifications(
            access_token,
            (notifications, count) => {
                setNotificationData([...notifications]);
                setUnreadCount(count);
                updateUnreadCount && updateUnreadCount(count);
                setLoading(false);
            },
            true  
        );
    };
    return (
        <>
            <div
                onClick={onClose}
                style={{
                    position: "fixed",
                    inset: 0,
                    background: open ? "rgba(0,0,0,0.3)" : "transparent",
                    visibility: open ? "visible" : "hidden",
                    transition: "0.3s",
                    zIndex: 9998
                }}
            />
            <div className='bg-white d-flex flex-column'
                style={{
                    position: "fixed", top: 0, right: 0, height: "100vh", width: "450px",
                    boxShadow: "-5px 0 25px rgba(0,0,0,0.15)",
                    transform: open ? "translateX(0)" : "translateX(100%)",
                    transition: "transform 0.35s ease",
                    zIndex: 9999,
                }}
            >
                <div className="d-flex justify-content-between align-items-center p-3 tab_active">
                    <b>Notifications ({unreadCount})</b>
                    <div className="d-flex gap-2 align-items-center mt-2">
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm ml0 "
                            disabled={loading}
                            onClick={handleRefresh}
                            style={{ padding: "4px 8px" }}
                        >
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className={[loading ? 'fa-spin' : ''].join(" ")} />
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-secondary "
                            onClick={onClose}
                            disabled={loading}
                        >
                            <TapIcon.imageIcon
                                icon={TapIcon.CloseIcon}
                                className="cursor_pointer img-fluid"
                                color="white"
                            />
                        </button>
                    </div>
                </div>
                <div style={{ flex: 1, overflowY: "auto" }}>
                    {loading ? <Loader /> :
                        notificationData && notificationData.length > 0 ?
                            <>
                                {notificationData.map(item => (
                                    <div
                                        key={item.id}
                                        className='d-flex align-items-start cursor_pointer gap-2 p-3'
                                        style={{
                                            borderBottom: "1px solid #eee",
                                            background: item.is_read === 1 ? "#fff" : "#f4f8ff"
                                        }}
                                    >
                                        <span
                                            className='d-flex align-items-center justify-content-center mt-1 cursor_pointer'
                                            onClick={() => !loading && markNotificationAsRead(item.id, item.is_read)}
                                            style={{
                                                width: 18,
                                                height: 18,
                                                minWidth: 18,
                                                borderRadius: "50%",
                                                border: item.is_read === 1 ? "2px solid #bbb" : "2px solid #2b7cff",
                                            }}
                                        >
                                            <span style={{
                                                width: 6, height: 6, borderRadius: "50%",
                                                background: item.is_read === 1 ? "#bbb" : "#2b7cff",
                                            }} />
                                        </span>
                                        <div style={{ flex: 1 }} onClick={() => handleNotificationClick(item)}>
                                            <div className='d-flex align-items-center justify-content-between mb-1'>
                                                <div className='fs14' style={{ color: item.is_read === 1 ? "#333" : "#000" }}>
                                                    {item?.title || "-"}
                                                </div>
                                                <div className='ms-2 fs11' style={{ color: "#999", whiteSpace: "nowrap" }}>
                                                    {item?.created_at ? DateService.dateTimeFormat(item.created_at, 'DD-MMM-YYYY HH:mm A') : "-"}
                                                </div>
                                            </div>
                                            <div style={{ color: item.is_read === 1 ? "#666" : "#333" }}>
                                                {item?.body || "-"}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className='p-3 text-center' style={{ borderTop: "1px solid #eee" }}>
                                    <button className='border-0 bg-transparent cursor_pointer'
                                        onClick={handleViewAll}
                                        style={{ color: "#2b7cff", padding: "8px 16px", borderRadius: "4px", transition: "all 0.2s" }}
                                    >
                                        View All Notifications
                                    </button>
                                </div>
                            </>
                            : <h6 className='text-center mt-5 pt-5'>No Notifications</h6>
                    }
                </div>
            </div>
        </>
    );
}

export default AllNotifications;